import { connect } from "react-redux";
import * as financingActions from "../../../services/financing/actions";
import * as mplFinancingActions from "../../../services/financing/mpl.financing/actions";

//Used to format the dates correctly without timezone (ToDo add this globally somehow?)
import moment from "moment";

function mapStateToProps(state) {
  return {
    financings: state.mplFinancing.financings,
    financingsIssued: state.mplFinancing.financingsIssued,
    financingsReady: state.mplFinancing.financingsReady,
    accountInfo: state.financing.accountInfo,
    investmentInfo: state.financing.investmentInfo,
    isMPL: true,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getFinancings: () => {
      dispatch(financingActions.get_financings());
    },

    getInvestmentInfo: (creditId) => {
      dispatch(financingActions.get_investment_info(creditId));
    },

    getFinancingBookingAccountInfo: (accountId) => {
      dispatch(financingActions.get_financing_booking_account_info(accountId));
    },

    realiseFinancing: (financingId) => {
      dispatch(mplFinancingActions.realise_financing(financingId));
    },

    changeFinancingListPage: (page) => {
      dispatch(
        mplFinancingActions.change_financing_list_page(page, "InProgress"),
      );
    },

    changeFinancingListFilter: (type, key, value) => {
      dispatch(
        mplFinancingActions.change_financing_list_filter(
          key,
          value,
          "InProgress",
        ),
      );
    },

    changeFinancingIssuedListPage: (page) => {
      dispatch(mplFinancingActions.change_financing_list_page(page, "Issued"));
    },

    changeFinancingIssuedListFilter: (type, key, value) => {
      dispatch(
        mplFinancingActions.change_financing_list_filter(key, value, "Issued"),
      );
    },

    changeFinancingReadyBeRealisedListPage: (page) => {
      dispatch(mplFinancingActions.change_financing_list_page(page, "Ready"));
    },

    changeFinancingReadyBeRealisedListFilter: (type, key, value) => {
      dispatch(
        mplFinancingActions.change_financing_list_filter(key, value, "Ready"),
      );
    },

    openFinancing: (financingId, shouldPublish) => {
      dispatch(mplFinancingActions.open_financing(financingId, shouldPublish));
    },

    closeFinancing: (financingId, shouldUnpublish) => {
      dispatch(
        mplFinancingActions.close_financing(financingId, shouldUnpublish),
      );
    },

    publishFinancing: (financingId) => {
      dispatch(mplFinancingActions.publish_financing(financingId));
    },

    unPublishFinancing: (financingId) => {
      dispatch(mplFinancingActions.unpublish_financing(financingId));
    },

    cancelFinancing: (financingId) => {
      dispatch(mplFinancingActions.cancel_financing(financingId));
    },

    getFinancingPayoutInfo: (financingId, offerId, assetType) => {
      dispatch(
        mplFinancingActions.get_financing_payout_info(
          financingId,
          offerId,
          assetType,
        ),
      );
    },

    registerPayout: (financingId, bankingDate, assetType) => {
      bankingDate = moment(bankingDate).format("YYYY-MM-DD");
      dispatch(
        mplFinancingActions.register_financing_payout(
          financingId,
          bankingDate,
          assetType,
        ),
      );
    },
  };
}

export const mplFinancingConnector = connect(
  mapStateToProps,
  mapDispatchToProps,
);
